import React, { useEffect, useState, useRef } from 'react';
import { Button, Modal } from 'react-bootstrap';

const ConfModal = ({ openModal, header, subHeader, modalConf, closeModal, primaryBtn, secondaryBtn, propCalss = 'addfrom change_type' }) => {
    const [confModal, setConfModal] = useState(true);
    const closeConfirm = () => {
        // setConfModal(false);
        closeModal()
    }
    const handleConfirmation = () => {
        modalConf();
        // closeConfirm();
        // setConfModal(false);
    };

    return (
        <Modal show={confModal} onHide={closeConfirm} className={propCalss} centered>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
                <h3>{header}</h3>
                <p>{subHeader}</p>
            </Modal.Body>
            <Modal.Footer>
                <div className="d-flex w-50 mx-auto are_bottom">
                    <Button variant="secondary" onClick={closeConfirm}> {secondaryBtn} </Button>
                    <Button variant="primary" onClick={handleConfirmation}> {primaryBtn} </Button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}

export default ConfModal